import { Component, OnInit } from '@angular/core';
import { Globals } from '../../_models/globals';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { ApiIntegration } from '../../_services/api.integration';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AlertService } from '../../_services/alert.service';
import * as moment from 'moment';
import { User } from '../../_models/user';
import { ExcelServiceService } from '../../_models/excel-service.service';

@Component({
  selector: 'app-credits-reports',
  templateUrl: './credits-reports.component.html',
  styleUrls: ['./credits-reports.component.scss'],
})
export class CreditsReportsComponent implements OnInit {

  startDate: any;
  startDateError: string;
  endDate: any;
  endDateError: string;
  getCreditsReportsData: any;

  constructor(public g: Globals, private excelService: ExcelServiceService, public user: User, private router: Router, public alertService: AlertService, private api: ApiIntegration) { }
  getReports() {
    this.startDate = moment(this.startDate).format('MM/DD/YYYY');
    this.endDate = moment(this.endDate).format('MM/DD/YYYY');
    this.g.loaderDisplay = "display";
    this.api.getCreditTransactionReports(this.startDate, this.endDate).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.getCreditsReportsData = data.creditTransactionslist;
      this.alertService.success('DotZot', 'Create Successfully');
    }, err => {
      this.alertService.error('Error', err);

    });
  }
  ngOnInit() { }



  typeStartError() {
  }

  typeEndError() {
  }




  clearFields() {
    this.startDate = "";
    this.endDate = "";
    this.startDateError = "";
    this.endDateError = "";
  }


  exportToXLSX() {
  }


}
